<template>
  <action-modal :is-open="true" @close="close">
    <span slot="title">{{ title }}</span>
    <v-layout>
      <v-flex xs6>
        <v-list three-line>
          <div three-line v-for="(field, index) in fields" :key="index">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ field.label }}</v-list-item-title>
                <v-list-item-subtitle>{{ field.value }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list>
      </v-flex>
      <v-flex xs6>
        <v-radio-group v-model="priceSelection" mb-0 pb-0>
          <template v-slot:label>
            <div>Set Markup or Custom Price</div>
          </template>
          <v-layout align="center">
            <v-radio label="Markup" value="customMarkup"></v-radio>
            <v-text-field
              v-model="markup"
              type="number"
              min="1.01"
              :readonly="priceSelection === 'customPrice'"
              :disabled="priceSelection === 'customPrice'"
              class="ml-6 mb-4"
            ></v-text-field>
          </v-layout>
          <v-layout align="center">
            <v-radio label="Custom Price" value="customPrice"></v-radio>
            <v-text-field
              prefix="$"
              type="number"
              min="1.01"
              v-model="customPrice"
              :readonly="priceSelection === 'customMarkup'"
              :disabled="priceSelection === 'customMarkup'"
              class="ml-6 mb-4"
            ></v-text-field>
          </v-layout>
          <v-layout mt-6 align="center">Cost: {{ cost }}</v-layout>
          <v-layout mt-6 align="center"
            >Customer Price: {{ finalCustomerPrice }}</v-layout
          >
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout wrap mt-4></v-layout>
    <div slot="actions">
      <v-layout>
        <v-btn
          @click="setProductPrice"
          :disabled="!validPricing"
          color="primary"
          >Add</v-btn
        >
      </v-layout>
    </div>
  </action-modal>
</template>

<script>
import request from "@/modules/request";
import ActionModal from "./ActionModal";
import commonFields from "../../../modules/commonProductFields";
import { get } from "lodash";
import { currencyFormatter } from "@/utils/";

export default {
  name: "AddMarkupModal",
  props: {
    title: {
      type: String,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      commonFields,
      markup: "",
      customPrice: "",
      priceSelection: "customMarkup",
    };
  },
  computed: {
    cost() {
      return currencyFormatter(this.product.invoicePrice, "en", "USD");
    },
    finalCustomerPrice() {
      const { markup, customPrice, priceSelection } = this;
      const { invoicePrice } = this.product;
      let returnedPrice;
      if (priceSelection === "customMarkup") {
        returnedPrice =
          markup && parseFloat(markup) > 1
            ? parseFloat(markup) * invoicePrice
            : 0;
      } else if (priceSelection === "customPrice") {
        returnedPrice = customPrice || 0;
      } else {
        returnedPrice = 0;
      }

      return returnedPrice > 0
        ? currencyFormatter(returnedPrice, "en", "USD")
        : "";
    },
    fields() {
      const { product, commonFields } = this;
      const display = [];

      commonFields.forEach((field) => {
        const { path, label } = field;
        const value = get(product, path);
        if (value) {
          // Some common fields might be missing, like subcategory
          display.push({
            label,
            value: get(product, path),
          });
        }
      });

      const { attributes } = product;
      attributes.forEach((attr) => {
        const { text, value } = attr;
        display.push({
          label: text,
          value,
        });
      });

      if (product.price) {
        display.push({
          label: "Price",
          value: product.price.formattedPrice,
        });
      }

      return display;
    },
    validPricing() {
      const { markup, customPrice, priceSelection } = this;

      return priceSelection === "customMarkup"
        ? markup && parseFloat(markup) > 1
        : customPrice && parseFloat(customPrice) > 1;
    },
  },
  components: {
    ActionModal,
  },
  methods: {
    close() {
      this.$emit("update:addMarkupModal", false);
    },
    setProductPrice() {
      const { markup, customPrice, priceSelection, product } = this;
      const { _id, description, manufacturer, productCode } = product;

      // Note - adding description, manufacturer, productCode
      // so that the UI can use it without recalling the b
      this.$emit("setProductPrice", {
        _id,
        priceSelection,
        customPrice,
        markup,
        description,
        manufacturer,
        productCode,
      });
      this.$emit("update:addMarkupModal", false);
    },
  },
};
</script>
